import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const Checkmark = createSvgIcon(
  <path d="M24 4.62 8.254 20.232 0 12.118l1.577-1.604 6.67 6.558 14.17-14.05 1.585 1.597Z" />,
  'Checkmark'
);

export { Checkmark };
